
import { GridColumnMenuCheckboxFilter, GridColumnMenuProps } from '@progress/kendo-react-grid';
import { orderBy } from '@progress/kendo-data-query';

export const CheckboxColumnFilter = (props: GridColumnMenuProps) => {
     const filteredData = props.data.filter((item: any) => {
        const value = item[props.column.field ?? ''];
        return value !== '-' && value !== null && value !== undefined && value !== '';
    }) as (string | object)[];
    const sortedData = orderBy(filteredData, [{ field: props.column.field ?? '', dir: "asc" }]) as (string | object)[];
    return (
        <div>
            <GridColumnMenuCheckboxFilter {...props} data={sortedData} expanded={true} />
        </div>
    );
};

export const RolesNotSignedColumnFilter = (props: any) => {
    // Extract all unique roles from comma-separated values using raw data
    const allRoles = new Set<string>();
    
    // Use raw data if available to get full role names for filter options
    const dataToProcess = props.rawData || props.data;
    
    dataToProcess.forEach((item: any) => {
        const value = item[props.column.field ?? ''];
        if (value && value !== '-' && typeof value === 'string') {
            value.split(',').forEach((role: string) => {
                const trimmedRole = role.trim();
                if (trimmedRole) {
                    allRoles.add(trimmedRole);
                }
            });
        }
    });
    
    // Create mock data objects for each unique role
    const uniqueRoleData = Array.from(allRoles).sort().map(role => ({
        [props.column.field ?? '']: role
    }));

    const customProps = {
        ...props,
        data: uniqueRoleData,
    };
    return (
        <div>
            <GridColumnMenuCheckboxFilter 
                {...customProps}
                expanded={true} 
                searchBox={() => null} 
            />
        </div>
    );
};
